import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../contexts/AppContext';
import { translations } from '../data/menuData';
import { CategorySection } from './CategorySection';
import { toast } from 'sonner';

const EMPTY_INITIAL = { opacity: 0, scale: 0.95 };
const EMPTY_ANIMATE = { opacity: 1, scale: 1 };

const getLocalizedText = (value, language) =>
  typeof value === 'string' ? value : value[language];

const EmptyState = ({ message }) => (
  <div className="mx-auto max-w-7xl px-4 md:px-8 py-12">
    <motion.div
      initial={EMPTY_INITIAL}
      animate={EMPTY_ANIMATE}
      className="rounded-2xl border border-border bg-card p-12 text-center"
    >
      <p className="text-lg text-muted-foreground">{message}</p>
    </motion.div>
  </div>
);

export const MenuGrid = ({ filteredCategories }) => {
  const { language, addToCart } = useApp();
  const t = translations[language];

  const handleAddToCart = (item, categoryTitle) => {
    const name = getLocalizedText(item.name, language);
    const price = getLocalizedText(item.price, language);
    addToCart({ name, price, category: categoryTitle });
    toast.success(t.itemAdded);
  };

  if (filteredCategories.length === 0) {
    return <EmptyState message={t.emptyCart} />;
  }

  return (
    <section className="py-8">
      <div className="mx-auto max-w-7xl px-4 md:px-8 space-y-12">
        {filteredCategories.map((category) => (
          <CategorySection
            key={category.id}
            category={category}
            language={language}
            onAddToCart={handleAddToCart}
            translations={t}
          />
        ))}
      </div>
    </section>
  );
};
